import React from 'react';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';

import TableData from '../../../../components/Table/TableData';
import UserCardSmall from '../../../../components/UserCardSmall/UserCardSmall';
import TableRow from '../../../../components/Table/TableRow';
import { permissions } from '../../../../common/permissionGroup';
import PermissionsGate from '../../../../components/PermissionsGate/PermissionsGate';
import ButtonDropdownList from '../../../../components/ButtonDropdownList/ButtonDropdownList';
import Badge from '../../../../components/Badge/Badge';
import accountStatus from '../../../../constants/accountStatus';
import ButtonTypes from '../../../../constants/buttonTypes';

const RoleUserRow = ({ user, actionList }) => {
  return (
    <TableRow key={user.id}>
      <TableData>
        {user.id}
      </TableData>
      <TableData>
        <div>
          <UserCardSmall user={user} />
        </div>
      </TableData>
      <TableData>
        {user?.login}
      </TableData>
      <TableData>
        <Badge
          text={user?.account_status}
          type={user?.account_status === accountStatus.ACTIVE ? ButtonTypes.SUCCESS : ButtonTypes.DANGER}
        />
      </TableData>
      <TableData>
        {DateTime.fromISO(user?.created_at).setLocale('en').toFormat('DD')}
      </TableData>
      <TableData>
        <PermissionsGate can={permissions.ADMIN_ADMIN}>
          <div className="d-row d-flex d-justify-end">
            <ButtonDropdownList actionList={actionList} item={user} label="Action" />
          </div>
        </PermissionsGate>
      </TableData>
    </TableRow>
  );
};

RoleUserRow.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    login: PropTypes.string,
    created_at: PropTypes.string,
    account_status: PropTypes.string,
  }),
  actionList: PropTypes.arrayOf(PropTypes.shape({}))
};

RoleUserRow.defaultProps = {
  user: {},
  actionList: []
};

export default RoleUserRow;
